import React from "react";
import { Restaurant } from "@/model/entities"
import SocialLink from './SocialLink';
import SocialPlatformEnum, { socialPlatform } from './socialTypes';
import { useTranslation } from "react-i18next";

interface SocialLinkListProps {
    restaurant: Restaurant
}

const SocialLinkList: React.FC<SocialLinkListProps> = ({ restaurant }) => {
  const { t } = useTranslation();
  const socialPlatforms: Record<string, string | undefined> = {};
  // Safely iterate known social platform keys from the enum and pick values from restaurant
  Object.values(SocialPlatformEnum).forEach((platform) => {
    // Treat platform as a key of Restaurant to avoid `any`
    const key = platform as keyof Restaurant;
    const value = restaurant?.[key] as unknown;
    if (typeof value === 'string' && value.length > 0) {
      socialPlatforms[platform] = value;
    }
  });
  return (
    <>
      {Object.entries(socialPlatforms).map(([platform, value]) => (
        <SocialLink
          key={platform}
          displayName={t(platform)}
          value={value}
          type={platform as socialPlatform}
        />
      ))}
    </>
  )
}

export default SocialLinkList